// extracted by mini-css-extract-plugin
export default {"wrap":"oH-z","articleImagesWrap":"pH-z","articleImage":"qH-z","singleImage":"rH-z"};